// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".integrations-loading[data-v-7b7102ce]{padding:106px 16px}.integrations-loading__spinner[data-v-7b7102ce]{margin:0 auto;width:150px;height:150px}.integrations-loading__heading[data-v-7b7102ce]{font-size:28px;color:#333}@media (min-width:576px){.integrations-loading__heading[data-v-7b7102ce]{font-size:48px}}.integrations-loading__link[data-v-7b7102ce]{font-weight:700;color:#80cacb}", ""]);
// Exports
module.exports = exports;
